import { useEffect } from 'react';

const SITE = 'Architech';

function setMeta(attribute: 'name' | 'property', key: string, content: string | null) {
  let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (content === null) {
    tag?.remove();
    return;
  }
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }
  tag.content = content;
}

/**
 * Per-route document title, description and robots directive. Private screens (account,
 * workspace, sign-in) pass `noindex` so a crawler that follows a stray link never lists them.
 * Values are restored to the index.html defaults by the next page that sets its own.
 */
export function usePageMeta(title: string | null | undefined, options: { description?: string | null; noindex?: boolean } = {}) {
  const { description, noindex = false } = options;
  useEffect(() => {
    if (!title) return;
    const full = title === SITE ? SITE : `${title} | ${SITE}`;
    document.title = full;
    setMeta('property', 'og:title', full);
    if (description) {
      const text = description.length > 160 ? `${description.slice(0, 157).trimEnd()}…` : description;
      setMeta('name', 'description', text);
      setMeta('property', 'og:description', text);
    }
    setMeta('name', 'robots', noindex ? 'noindex,nofollow' : 'index,follow');
  }, [title, description, noindex]);
}
